var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleUpperbody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 317,
    viewBox: "0 0 165 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upperBody",
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3011 25.7143C99.304 25.6043 99.3113 25.4967 99.3127 25.3867C99.3127 25.3221 99.3185 25.2576 99.3185 25.1931V25.1235C99.3156 12.8998 98.5362 3.13045 82.6994 3.00014C82.5459 3.00014 82.401 3.00647 82.2489 3.00647C82.0982 3.00647 81.9519 2.99888 81.7968 3.00014C65.963 3.13045 65.1835 12.8998 65.1806 25.1235C65.1806 25.1463 65.1806 25.1703 65.1806 25.1931C65.1806 25.2589 65.185 25.3221 65.185 25.3867C65.185 25.4082 65.1864 25.4284 65.1879 25.4499C64.3418 25.6979 63.2885 26.3026 63.4899 26.8175C63.8043 27.6247 65.7399 34.13 66.4121 33.2216C66.4556 33.1622 66.4918 33.0736 66.5237 32.9686C69.456 41.3893 76.6058 47.3861 81.7983 47.3861C81.9461 47.3861 82.0996 47.3747 82.2503 47.3658C82.401 47.3759 82.5546 47.3861 82.7009 47.3861C87.8731 47.3861 94.9809 41.4387 97.9364 33.0736C97.9755 33.2545 98.0248 33.4013 98.0871 33.4873C98.7593 34.3957 100.696 27.8904 101.009 27.0832C101.212 26.5645 100.149 25.961 99.3011 25.7143Z",
    fill: "#A7A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4491 89.0847C83.7077 89.3276 85.1594 94.1276 85.3043 94.7576C85.4491 95.3876 94.6866 95.3876 96.2745 97.909C97.8624 100.43 96.7077 95.1359 96.7077 94.1276C96.7077 93.1192 92.6656 88.0752 85.4477 89.0847H85.4491Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0161 96.7679C84.1715 96.9412 85.0161 103.072 85.5928 105.087C85.7492 105.634 95.5532 104.457 96.2747 106.222C96.9962 104.457 97.1411 103.071 97.1411 102.062C97.1411 101.054 92.3775 95.2548 85.0147 96.7679H85.0161Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.306 107.115C84.5903 107.739 85.0177 115.183 85.1611 115.688C85.306 116.193 88.4803 114.553 89.9247 114.427C91.3692 114.301 96.2762 114.68 96.8543 113.923C97.4309 113.167 97.7207 109.259 96.5645 107.999C95.4113 106.737 88.0471 104.721 85.3045 107.115H85.306Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6273 116.525C88.1771 117.441 85.6475 118.161 85.1709 119.924C84.6928 121.686 84.374 138.682 84.374 139.941C84.374 141.199 85.4881 142.332 87.3977 142.332C89.3072 142.332 91.2196 138.554 92.015 136.541C92.8103 134.527 94.5619 128.485 94.8792 126.722C95.1965 124.96 97.7449 116.777 96.3121 116.022C94.8792 115.267 91.2181 115.518 89.6259 116.525H89.6273Z",
    fill: "#A7A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8768 104.836C98.7623 106.498 97.8786 123.323 97.5048 124.714C97.131 126.103 97.88 128.47 98.7522 128.332C99.6273 128.193 102.447 127.32 102.697 125.79C102.946 124.262 102.829 114.703 102.829 112.896C102.829 111.089 102.787 102.511 102.164 102.093C101.541 101.677 99.0028 103.029 98.8783 104.836H98.8768Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9407 98.4064C98.9407 98.4064 98.6654 100.975 99.0334 101.295C99.4 101.616 101.88 99.7702 102.063 99.2882C102.247 98.8062 103.477 94.6477 102.741 95.4498C102.005 96.2519 101.42 97.6043 98.9392 98.4064H98.9407Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3259 94.2832C99.2332 94.9259 98.8667 97.0121 99.3259 97.0918C99.7852 97.1728 102.083 94.3085 102.36 93.6659C102.634 93.0244 102.481 92.4994 102.206 92.6601C101.931 92.8208 99.4172 93.6418 99.3274 94.2832H99.3259Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6729 90.4145C98.4266 90.8446 97.947 92.9991 99.0481 92.8397C100.152 92.6791 102.531 90.3753 102.396 89.644C102.243 88.8052 98.8554 90.0944 98.6729 90.4157V90.4145Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1472 87.2821C96.617 87.7363 97.6152 89.3683 98.2164 89.2127C98.7496 89.0748 102.782 87.1303 102.514 86.1915C102.283 85.3844 97.2675 87.1809 97.1472 87.2821Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3012 146.03C85.8057 146.952 86.7662 160.064 88.4584 163.44C90.1492 166.818 89.5552 160.937 89.7899 159.689C90.0231 158.441 92.0094 156.381 91.1054 154.92C90.1984 153.459 86.4243 145.802 86.3012 146.031V146.03Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6869 138.052C94.8422 138.812 89.3339 142.91 89.444 143.611C89.6106 144.66 92.8762 151.585 94.0888 152.228C95.3015 152.87 95.0668 148.179 96.2157 145.603C97.4442 142.852 104.759 128.234 104.753 127.861C104.749 127.576 98.9597 135.108 95.6869 138.05V138.052Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.05 126.72C108.353 139.077 88.9565 174.166 87.0962 186.91C86.5978 156.691 104.357 141.356 107.05 126.72Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.668 158.133C101.462 154.887 109.741 129.413 109.946 130.204C117.229 158.432 101.005 186.246 100.106 189.87C99.2044 193.495 99.7332 204.285 99.5883 205.259C99.4434 206.235 97.531 206.116 96.8819 205.291C96.2329 204.465 91.6243 172.68 99.668 158.132V158.133Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.738 151.376C111.742 166.797 104.375 182.204 102.932 188.218C102.028 191.974 102.125 199.458 102.154 201.403C102.184 203.35 102.682 204.733 103.478 204.724C103.896 204.721 110.435 186.06 111.342 181.259C115.532 166.97 113.625 161.165 112.738 151.375V151.376Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9831 173.941C94.2479 173.293 91.6488 187.614 91.8371 189.559C92.0269 191.503 95.5939 208.338 91.288 207.832C86.9822 207.324 87.5487 195.623 87.4966 192.15C87.4444 188.675 91.8791 174.509 92.9846 173.941H92.9831Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5489 226.731C89.994 227.227 86.1519 248.23 86.1997 250.957C86.3489 259.597 91.7572 274.276 91.7862 276.223C91.8152 278.169 93.4364 270.071 93.5697 268.262C93.7001 266.453 97.7393 239.816 90.5489 226.731Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.676 235.284C104.676 235.284 106.952 244.859 105.755 250.784C105.418 252.455 99.0027 269.707 98.7709 270.823C98.5405 271.937 94.9634 281.102 94.8113 279.372C94.6606 277.645 96.3383 273.796 96.5672 272.557C96.7976 271.318 99.2866 255.594 99.6314 253.862C99.9777 252.128 104.676 235.285 104.676 235.285V235.284Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.773 287.009C97.7191 286.889 97.9437 290.609 97.9668 292.138C97.99 293.667 99.7778 296.149 98.8376 297.134C97.8973 298.117 95.2431 299.479 93.677 301.166C92.1108 302.853 89.9347 306.215 89.7551 304.965C89.5754 303.715 89.0162 298.3 89.7913 296.901C90.565 295.503 93.1192 287.468 96.773 287.009Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.771 300.559C99.3954 301.614 105.805 308.275 105.821 309.387C105.838 310.501 97.199 310.772 96.2428 310.782C95.2881 310.792 95.2359 310.759 94.4057 308.544C93.577 306.328 93.5408 303.965 94.1696 303.402C94.7984 302.84 98.4435 300.008 98.771 300.559Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6646 304.704C90.8272 304.861 89.3161 307.372 89.3306 308.207C89.3422 309.041 89.0568 310.482 89.8522 310.47C90.6476 310.462 93.0453 311.13 93.1844 309.739C93.322 308.346 93.2525 304.409 91.6646 304.704Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.22 283.671C91.7647 283.382 93.5294 282.087 94.5102 281.566C95.491 281.047 96.4979 283.309 95.675 283.835C94.8521 284.363 91.2041 290.628 90.852 291.31C90.5014 291.992 90.2421 284.191 91.2214 283.671H91.22Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5815 209.815C90.7699 217.591 95.5842 222.127 94.2035 230.976C94.2093 225.752 87.8462 223.1 90.5815 209.815Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.018 210.944C103.323 209.854 101.634 222.46 101.67 223.589C101.707 224.715 97.5818 225.71 96.4866 226.96C96.3417 226.045 97.2312 223.64 97.4558 222.783C97.6818 221.925 101.504 216.329 103.018 210.944Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9065 211.801C92.8805 210.037 94.6176 209.46 96.5517 209.437C98.4844 209.415 99.8825 209.954 99.91 211.72C99.9332 213.203 96.3127 220.853 95.6621 220.027C95.0638 219.267 93.7526 215.582 93.4006 213.697C93.0963 213.029 92.9152 212.353 92.9065 211.8V211.801Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.32 227.045C104.097 229.137 103.727 237.544 102.189 242.258C100.647 246.972 98.3115 256.514 97.6161 259.612C96.9193 262.709 93.9362 278.686 93.7102 280.049C93.4842 281.41 92.2469 281.671 92.3454 279.939C92.4425 278.208 94.8098 270.765 94.9069 269.035C95.0039 267.303 96.5208 250.948 97.6422 245.493C98.9505 239.127 102.955 226.053 103.321 227.045H103.32Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0454 89.0847C80.7869 89.3276 79.3338 94.1276 79.1889 94.7576C79.0454 95.3876 69.805 95.3876 68.2186 97.909C66.6293 100.43 67.7869 95.1359 67.7869 94.1276C67.7869 93.1192 71.829 88.0752 79.0469 89.0847H79.0454Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4789 96.7679C80.3236 96.9412 79.4789 103.072 78.9023 105.087C78.7458 105.634 68.9404 104.457 68.2189 106.222C67.4974 104.457 67.3525 103.071 67.3525 102.062C67.3525 101.054 72.1162 95.2548 79.4789 96.7679Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1894 107.115C79.9051 107.739 79.4792 115.183 79.3343 115.688C79.1894 116.193 76.0136 114.553 74.5721 114.427C73.1277 114.301 68.2191 114.68 67.6411 113.923C67.0645 113.167 66.7762 109.259 67.9308 107.999C69.0855 106.737 76.4483 104.721 79.1909 107.115H79.1894Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.866 116.525C76.3162 117.441 78.8458 118.161 79.3224 119.924C79.7991 121.686 80.1178 138.682 80.1178 139.941C80.1178 141.199 79.0037 142.332 77.0942 142.332C75.1847 142.332 73.2737 138.554 72.4769 136.541C71.6815 134.527 69.9314 128.485 69.6141 126.722C69.2939 124.96 66.7484 116.777 68.1812 116.022C69.6141 115.267 73.2737 115.518 74.866 116.525Z",
    fill: "#A7A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6169 104.836C65.7314 106.498 66.6151 123.323 66.9904 124.714C67.3642 126.103 66.6151 128.47 65.7415 128.332C64.8679 128.193 62.0485 127.32 61.7979 125.79C61.5487 124.262 61.6646 114.703 61.6646 112.896C61.6646 111.089 61.7052 102.511 62.3296 102.093C62.954 101.677 65.4909 103.029 65.6155 104.836H65.6169Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5531 98.4064C65.5531 98.4064 65.8284 100.975 65.4618 101.295C65.0953 101.616 62.6135 99.7702 62.4295 99.2882C62.2455 98.8062 61.0169 94.6477 61.7515 95.4498C62.4874 96.2519 63.0728 97.6043 65.5531 98.4064Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1696 94.2832C65.2609 94.9259 65.6289 97.0121 65.1696 97.0918C64.7103 97.1728 62.4111 94.3085 62.1358 93.6659C61.8605 93.0244 62.0156 92.4994 62.2894 92.6601C62.5661 92.8208 65.0769 93.6418 65.1696 94.2832Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8212 90.4145C66.0675 90.8446 66.5485 92.9991 65.4459 92.8397C64.3434 92.6791 61.9645 90.3753 62.0992 89.644C62.2528 88.8052 65.6386 90.0944 65.8226 90.4157L65.8212 90.4145Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3484 87.2821C67.8786 87.7363 66.8818 89.3683 66.2792 89.2127C65.746 89.0748 61.7155 87.1303 61.9835 86.1915C62.2138 85.3844 67.2296 87.1809 67.3484 87.2821Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1939 146.03C78.6894 146.952 77.7289 160.064 76.0367 163.44C74.3445 166.818 74.9385 160.937 74.7067 159.689C74.4734 158.441 72.4857 156.381 73.3912 154.92C74.2967 153.459 78.0708 145.802 78.1954 146.031L78.1939 146.03Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8073 138.052C69.6533 138.812 75.1617 142.91 75.0501 143.611C74.8835 144.66 71.6194 151.585 70.4053 152.228C69.1926 152.87 69.4273 148.179 68.2784 145.603C67.0499 142.852 59.7335 128.234 59.7393 127.861C59.7436 127.576 65.5344 135.108 68.8058 138.05L68.8073 138.052Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4426 126.72C56.1401 139.077 75.5351 174.166 77.3968 186.91C77.8952 156.691 60.1359 141.356 57.4426 126.72Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.827 158.133C63.0305 154.887 54.7535 129.413 54.5492 130.204C47.2647 158.432 63.4883 186.246 64.3894 189.87C65.2891 193.495 64.7618 204.285 64.9066 205.259C65.0515 206.235 66.9625 206.116 67.613 205.291C68.2621 204.465 72.8692 172.68 64.827 158.132V158.133Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.756 151.376C52.7543 166.797 60.1185 182.204 61.5629 188.218C62.467 191.974 62.3713 199.458 62.3409 201.403C62.3119 203.35 61.8135 204.733 61.0182 204.724C60.5995 204.721 54.0582 186.06 53.1541 181.259C48.9642 166.97 50.8694 161.165 51.7575 151.375L51.756 151.376Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5109 173.941C70.2461 173.293 72.8453 187.614 72.6584 189.559C72.47 191.503 68.9016 208.338 73.2075 207.832C77.5147 207.324 76.9468 195.623 76.9989 192.15C77.0511 188.675 72.6178 174.509 71.5109 173.941Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9444 226.731C74.5007 227.227 78.3415 248.23 78.2951 250.957C78.1459 259.597 72.7361 274.276 72.7071 276.223C72.6781 278.169 71.0569 270.071 70.9251 268.262C70.7933 266.453 66.7555 239.816 73.9444 226.731Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8193 235.284C59.8193 235.284 57.5418 244.859 58.7399 250.784C59.0775 252.455 65.4927 269.707 65.7231 270.823C65.9549 271.937 69.532 281.102 69.6826 279.372C69.8333 277.645 68.1542 273.796 67.9267 272.557C67.6963 271.318 65.2073 255.594 64.8625 253.862C64.5177 252.128 59.8193 235.285 59.8193 235.285V235.284Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7203 287.009C66.7742 286.889 66.5511 290.609 66.5279 292.138C66.5047 293.667 64.7155 296.149 65.6557 297.134C66.5974 298.117 69.2516 299.479 70.8178 301.166C72.3839 302.853 74.5614 306.215 74.7396 304.965C74.9179 303.715 75.4771 298.3 74.7034 296.901C73.9283 295.503 71.3756 287.468 67.7217 287.009H67.7203Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7237 300.559C65.1007 301.614 58.6898 308.275 58.6739 309.387C58.6565 310.501 67.2956 310.772 68.2518 310.782C69.2066 310.792 69.2587 310.759 70.0889 308.544C70.919 306.328 70.9553 303.965 70.3265 303.402C69.6977 302.84 66.0511 300.008 65.7251 300.559H65.7237Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8294 304.704C73.6683 304.861 75.1779 307.372 75.1648 308.207C75.1518 309.041 75.4387 310.482 74.6418 310.47C73.8465 310.462 71.4487 311.13 71.3111 309.739C71.1734 308.346 71.2415 304.409 72.8294 304.704Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2727 283.671C72.728 283.382 70.9663 282.087 69.9854 281.566C69.0046 281.047 67.9977 283.309 68.8192 283.835C69.6421 284.363 73.2901 290.628 73.6422 291.31C73.9928 291.992 74.2521 284.191 73.2727 283.671Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9139 209.815C73.7241 217.591 68.9098 222.127 70.289 230.976C70.2847 225.752 76.6478 223.1 73.9139 209.815Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4775 210.944C61.1718 209.854 62.8596 222.46 62.8248 223.589C62.7886 224.715 66.9119 225.71 68.0101 226.96C68.1535 226.045 67.2639 223.64 67.0408 222.783C66.8148 221.925 62.9929 216.329 61.4789 210.944H61.4775Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5875 211.801C71.6151 210.037 69.8765 209.46 67.9424 209.437C66.0082 209.415 64.6102 209.954 64.5841 211.72C64.5623 213.203 68.1829 220.853 68.8319 220.027C69.4303 219.267 70.7414 215.582 71.0921 213.697C71.3963 213.029 71.5774 212.353 71.5861 211.8L71.5875 211.801Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.356 138.039C143.737 138.311 143.886 142.055 143.909 143.368C143.932 144.681 146.266 152.362 148.437 152.064C150.604 151.765 151.439 150.386 151.854 149.596C152.269 148.807 154.951 147.364 155.363 146.632C155.773 145.899 151.582 140.128 150.836 139.714C150.093 139.298 149.622 137.806 148.338 137.437C147.815 137.289 144.724 137.877 144.356 138.04V138.039Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.145 139.112C151.072 138.681 152.014 138.357 152.351 138.495C152.689 138.634 157.887 141.781 158.432 142.17C160.137 143.381 163.055 144.166 162.822 144.842C162.286 146.386 158.828 144.784 156.969 143.448C155.107 142.112 151.34 140.271 151.143 139.112H151.145Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.649 147.759C156.176 147.826 155.299 148.004 155.408 148.939C155.512 149.874 159.263 157.569 160.118 158.327C160.971 159.088 161.522 158.203 161.252 156.908C160.981 155.613 157.187 147.686 156.649 147.759Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.133 149.769C153.746 150.053 153.256 150.573 152.997 151.189C152.737 151.808 157.45 161.832 158.156 162.061C158.867 162.285 159.45 161.75 159.408 160.823C159.367 159.893 154.561 149.454 154.134 149.769H154.133Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.849 151.805C151.296 151.997 150.865 152.369 150.81 152.944C150.752 153.518 153.969 161.924 155.519 161.696C157.065 161.463 155.451 159.025 155.238 158.489C155.023 157.952 152.126 151.712 151.851 151.806L151.849 151.805Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.513 153.039C147.424 152.557 148.927 153.493 149.211 153.976C149.496 154.463 151.54 159.085 151.079 159.214C149.447 159.668 147.902 155.151 147.513 153.037V153.039Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.151 54.9084C112.23 55.0198 115.052 54.9084 118.644 57.7082C120.926 59.4882 121.979 65.5482 120.953 70.2532C119.542 65.7734 115.181 58.6052 109.151 54.9084Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.512 55.8093C109.027 56.4811 118.156 67.236 118.924 73.2846C108.186 73.797 103.759 65.3851 103.512 55.8093Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7988 63.0609C85.5362 62.6194 90.9402 60.6546 99.2607 63.9908C107.271 67.2029 109.706 80.4413 109.604 80.7183C109.464 81.0966 96.621 87.3426 89.8928 87.3426C85.9651 87.3426 83.96 84.6618 83.96 83.6534C83.96 82.6451 83.9585 63.5657 84.8003 63.0609H84.7988Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.539 76.3045C113.463 76.1274 117.668 76.6018 119.39 77.7961C124.322 81.2119 124.071 88.8394 124.112 90.8017C124.154 92.7639 126.029 97.1311 122.954 97.1792C119.88 97.2285 112.785 88.0791 112.017 85.3009C111.25 82.5239 110.182 76.7536 112.539 76.3045Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.268 100.881C121.16 100.881 121.053 100.857 120.958 100.804C116.369 98.2734 112.999 93.2103 111.73 91.3025L111.523 90.9888C111.361 90.7497 111.075 88.0575 111.349 87.917C111.622 87.7753 111.977 87.8563 112.136 88.0954L112.349 88.4142C113.579 90.2613 117.221 97.5548 121.573 99.9535C121.841 100.102 121.923 100.411 121.753 100.647C121.643 100.797 121.457 100.88 121.269 100.881H121.268Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.638 98.5681C124.448 107.734 126.884 108.405 127.428 110.058C128.558 113.504 136.571 122.427 138.886 125.284C141.574 128.604 144.509 135.008 145.401 135.138C146.292 135.268 140.199 124.567 139.753 123.557C137.888 119.34 133.846 102.819 123.639 98.5681H123.638Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.659 104.16C120.442 104.14 128.641 112.38 128.548 113.933C128.454 115.487 124.768 112.85 122.475 111.791C120.18 110.732 118.991 110.668 119.03 110.002C119.07 109.337 118.536 104.189 119.659 104.16Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.286 114.938C130.33 115.379 143.542 134.674 143.756 136.133C141.056 133.018 132.053 124.239 131.313 123.414C129.822 121.75 125.549 116.754 124.286 114.938Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.864 113.317C121.864 113.317 121.934 113.416 122.064 113.602C122.208 113.778 122.353 114.084 122.626 114.398C122.893 114.718 123.199 115.107 123.528 115.553C123.842 115.999 124.316 116.481 124.73 117.04C125.563 118.17 126.67 119.386 127.733 120.778C128.241 121.494 128.858 122.16 129.415 122.894C130.001 123.605 130.553 124.367 131.182 125.061C132.477 126.413 133.668 127.88 134.976 129.057C135.618 129.66 136.239 130.242 136.827 130.795C137.42 131.345 137.95 131.907 138.521 132.319C140.741 134.078 142.528 135.754 142.528 135.754C142.565 135.777 142.572 135.821 142.552 135.856C142.528 135.888 142.279 135.825 142.447 135.876C142.447 135.876 140.564 134.311 138.199 132.723C137.588 132.347 137.014 131.829 136.375 131.321C135.745 130.8 135.079 130.251 134.392 129.684C132.994 128.565 131.707 127.159 130.309 125.86C129.617 125.201 129.001 124.474 128.355 123.794C127.722 123.099 127.071 122.438 126.525 121.729C125.437 120.307 124.478 118.942 123.758 117.701C123.022 116.493 122.471 115.365 122.145 114.599C121.828 113.833 121.727 113.372 121.727 113.372C121.717 113.331 121.744 113.292 121.782 113.283C121.812 113.275 121.846 113.293 121.863 113.317H121.864Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7216 51.5837C93.4413 51.5837 101.727 55.7283 102.624 56.5127C103.521 57.2971 97.4921 57.521 96.9793 57.521C96.4664 57.521 92.362 54.386 91.7201 53.489C91.0783 52.5933 90.8219 51.585 91.7201 51.585L91.7216 51.5837Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1739 55.7891C90.7563 56.805 93.2207 58.981 91.8487 59.5136C90.4767 60.045 88.1934 59.9121 88.1934 59.3808C88.1934 58.8494 89.8696 55.2577 90.1739 55.7891Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.952 83.3323C105.954 84.3722 102.717 87.5857 102.717 88.3574C102.717 88.9988 102.575 94.3959 103.255 93.7544C104.2 92.8613 104.066 90.1615 104.857 88.4725C105.756 86.5558 106.684 85.6449 106.952 83.3323Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2784 46.7991C90.0492 46.7991 89.5392 51.0524 89.4117 51.8368C89.2828 52.6212 83.6397 61.6935 83.2544 62.3665C82.8704 63.0383 82.2286 58.3346 82.8704 57.4376C83.5122 56.5419 88.7656 46.8003 89.2784 46.8003V46.7991Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7875 48.3804C82.72 48.7321 80.2585 48.4525 80.1006 48.4221C79.001 48.2083 82.423 55.0894 82.423 55.0894L82.4491 54.9806L82.465 55.0464C82.465 55.0464 85.8219 48.202 84.7875 48.3791V48.3804Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1383 138.039C20.757 138.311 20.6092 142.055 20.586 143.368C20.5643 144.681 18.2288 152.362 16.0585 152.064C13.8897 151.765 13.0552 150.386 12.6394 149.596C12.225 148.807 9.54331 147.364 9.13186 146.632C8.7204 145.899 12.9132 140.128 13.6579 139.714C14.4011 139.298 14.8705 137.806 16.1556 137.437C16.6772 137.289 19.7689 137.877 20.1383 138.04V138.039Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3501 139.112C13.4225 138.681 12.4794 138.357 12.1418 138.495C11.8057 138.634 6.60597 141.781 6.06122 142.17C4.356 143.381 1.43813 144.166 1.67138 144.842C2.20744 146.386 5.6657 144.784 7.5245 143.448C9.38475 142.112 13.1531 140.271 13.3501 139.112Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84447 147.759C8.31822 147.826 9.19474 148.004 9.08608 148.939C8.98177 149.874 5.2294 157.569 4.37606 158.327C3.52417 159.088 2.97218 158.203 3.24165 156.908C3.51113 155.613 7.30696 147.686 7.84447 147.759Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3631 149.769C10.7485 150.053 11.2396 150.573 11.499 151.189C11.7583 151.808 7.04539 161.832 6.33983 162.061C5.62992 162.285 5.04606 161.75 5.08807 160.823C5.12719 159.893 9.93428 149.454 10.3631 149.769Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6448 151.805C13.1982 151.997 13.6285 152.369 13.685 152.944C13.7415 153.518 10.5267 161.924 8.97791 161.696C7.4306 161.463 9.04601 159.025 9.25898 158.489C9.4705 157.952 12.371 151.712 12.6463 151.806L12.6448 151.805Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9825 153.039C17.0709 152.557 15.5699 153.493 15.2845 153.976C15.0006 154.463 12.9563 159.085 13.4156 159.214C15.0484 159.668 16.5942 155.151 16.9825 153.037V153.039Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3418 54.9084C52.2631 55.0198 49.4408 54.9084 45.8493 57.7082C43.5674 59.4882 42.5141 65.5482 43.5399 70.2532C44.951 65.7734 49.3119 58.6052 55.3418 54.9084Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.984 55.8093C55.4685 56.4811 46.3396 67.236 45.5703 73.2846C56.3117 73.797 60.7363 65.3851 60.984 55.8093Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2522 63.0609C79.5133 62.6194 74.1093 60.6546 65.7904 63.9908C57.78 67.2029 55.3446 80.4413 55.4474 80.7183C55.588 81.0966 68.4301 87.3426 75.1583 87.3426C79.0859 87.3426 80.9795 84.2392 80.9795 83.2309C80.9795 82.2226 81.094 63.5657 80.2522 63.0621V63.0609Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9545 76.3045C51.0316 76.1274 46.8258 76.6018 45.1032 77.7961C40.1729 81.2119 40.4221 88.8394 40.383 90.8017C40.341 92.7639 38.4633 97.1311 41.5391 97.1792C44.6149 97.2285 51.7082 88.0791 52.4775 85.3009C53.2454 82.5239 54.3117 76.7536 51.9545 76.3045Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2269 100.881C43.3327 100.881 43.4413 100.857 43.5369 100.804C48.1253 98.2734 51.4952 93.2103 52.7643 91.3025L52.9729 90.9888C53.1352 90.7497 53.4191 88.0575 53.1468 87.917C52.8744 87.7753 52.5194 87.8563 52.3601 88.0954L52.1457 88.4142C50.9171 90.2613 47.2734 97.5548 42.9212 99.9535C42.6532 100.102 42.572 100.411 42.743 100.647C42.8517 100.797 43.0386 100.88 43.2269 100.881Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8551 98.5681C40.0467 107.734 37.6083 108.405 37.065 110.058C35.935 113.504 27.9217 122.427 25.6065 125.284C22.919 128.604 19.9838 135.008 19.0928 135.138C18.2018 135.268 24.2939 124.567 24.7416 123.557C26.6062 119.34 30.6469 102.819 40.8551 98.5681Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8354 104.16C44.0516 104.14 35.8543 112.38 35.9471 113.933C36.0398 115.487 39.727 112.85 42.0204 111.791C44.3138 110.732 45.5048 110.668 45.4642 110.002C45.4236 109.337 45.9597 104.189 44.8354 104.16Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2091 114.938C34.1662 115.379 20.9532 134.674 20.7373 136.133C23.4379 133.018 32.4421 124.239 33.181 123.414C34.6703 121.75 38.9457 116.754 40.2091 114.938Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6301 113.317C42.6301 113.317 42.5605 113.416 42.4301 113.602C42.2867 113.778 42.1433 114.084 41.8694 114.398C41.6029 114.718 41.2986 115.107 40.9683 115.553C40.6554 115.999 40.1816 116.481 39.7672 117.04C38.9342 118.17 37.8273 119.386 36.7624 120.778C36.2568 121.494 35.6396 122.16 35.0804 122.894C34.4951 123.605 33.9431 124.367 33.3129 125.061C32.0177 126.413 30.8282 127.88 29.5185 129.057C28.8767 129.66 28.2537 130.242 27.6669 130.795C27.0744 131.345 26.5441 131.907 25.9733 132.319C23.7537 134.078 21.9659 135.754 21.9659 135.754C21.9312 135.777 21.9239 135.821 21.9428 135.856C21.9645 135.888 22.2166 135.825 22.0485 135.876C22.0485 135.876 23.9319 134.311 26.2949 132.723C26.9078 132.347 27.48 131.829 28.1204 131.321C28.7492 130.8 29.4171 130.251 30.1038 129.684C31.5004 128.565 32.7884 127.159 34.1865 125.86C34.879 125.201 35.4933 124.474 36.1424 123.794C36.774 123.099 37.4245 122.438 37.9722 121.729C39.0588 120.307 40.0179 118.942 40.7379 117.701C41.4739 116.493 42.0245 115.365 42.3519 114.599C42.6677 113.833 42.7706 113.372 42.7706 113.372C42.7778 113.331 42.7518 113.292 42.7141 113.283C42.6837 113.275 42.6518 113.293 42.633 113.317H42.6301Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7725 51.5837C71.0528 51.5837 62.7672 55.7283 61.8704 56.5127C60.9721 57.2971 67.002 57.521 67.5134 57.521C68.0248 57.521 72.1307 54.386 72.7725 53.489C73.4143 52.5933 73.6708 51.585 72.7725 51.585V51.5837Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3217 55.7891C73.7392 56.805 71.2748 58.981 72.6454 59.5136C74.0174 60.045 76.3022 59.9121 76.3022 59.3808C76.3022 58.8494 74.6273 55.2577 74.3231 55.7891H74.3217Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.543 83.3323C58.5412 84.3722 61.7778 87.5857 61.7778 88.3574C61.7778 88.9988 61.9198 94.3959 61.2417 93.7544C60.2957 92.8613 60.4304 90.1615 59.6394 88.4725C58.7426 86.5558 57.8124 85.6449 57.5444 83.3323H57.543Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2149 46.7991C74.4456 46.7991 74.9541 51.0524 75.0831 51.8368C75.212 52.6212 80.855 61.6935 81.2404 62.3665C81.6244 63.0383 82.2662 58.3346 81.6244 57.4376C80.9825 56.5419 75.7263 46.8003 75.2149 46.8003V46.7991Z",
    fill: "#F38A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1717 227.045C60.398 229.137 60.7645 237.544 62.3061 242.258C63.8461 246.972 66.1816 256.514 66.8785 259.612C67.5753 262.709 70.5569 278.686 70.7829 280.049C71.0104 281.41 72.2462 281.671 72.1492 279.939C72.0506 278.208 69.6848 270.765 69.5862 269.035C69.4892 267.303 67.9723 250.948 66.8509 245.493C65.5427 239.127 61.5397 226.053 61.1702 227.045H61.1717Z",
    fill: "#A8A7A8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3817_15881)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 3.49683,
    width: 41,
    height: 43.8617,
    rx: 6.5,
    stroke: "#F28986",
    strokeLinejoin: "round",
    strokeDasharray: "5 5",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3817_15881)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 87.2266,
    width: 49,
    height: 55.8232,
    rx: 6.5,
    stroke: "#F28986",
    strokeLinejoin: "round",
    strokeDasharray: "5 5",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3817_15881)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 145.04,
    width: 63,
    height: 168.46,
    rx: 6.5,
    stroke: "#F28986",
    strokeLinejoin: "round",
    strokeDasharray: "5 5",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3817_15881",
    x: 58,
    y: -0.00317383,
    width: 48,
    height: 50.8618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3817_15881"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.627451 0 0 0 0 0.87451 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3817_15881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3817_15881",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3817_15881",
    x: 54,
    y: 83.7266,
    width: 56,
    height: 62.8232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3817_15881"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.627451 0 0 0 0 0.87451 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3817_15881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3817_15881",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3817_15881",
    x: 47,
    y: 141.54,
    width: 70,
    height: 175.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3817_15881"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.627451 0 0 0 0 0.87451 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3817_15881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3817_15881",
    result: "shape"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "lowerBodyTrigger",
    x: 47,
    y: 150,
    width: 68,
    height: 200,
    fill: "transparent"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "wholeBodyTrigger",
    x: 55,
    y: 1,
    width: 50,
    height: 50,
    fill: "transparent"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "middleBodyTrigger",
    x: 56,
    y: 86,
    width: 50,
    height: 63,
    fill: "transparent"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleUpperbody);
export default __webpack_public_path__ + "static/media/female_upperbody.2d84546de4aef910cae2270231519c65.svg";
export { ForwardRef as ReactComponent };